import { object } from 'prop-types';
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';

import GoogleAnalytic from '@components/Share/GoogleAnalytic';
import SitecoreContextFactoryService from '@services/sitecoreContextFactoryService';
import { useDidUpdateEffect } from '@utils/customsHook/useDidUpdateEffect';
import global from '@utils/global';

const GA4ViewItemEvent = ({
  productDetailOverview,
  variantActiveDefault
}) => {
  const isGA4 = global.getIsGA4();
  const contextRouteItem = SitecoreContextFactoryService.getValueContextRouteItem('fields');
  const placeholders = SitecoreContextFactoryService.getValueContextRouteItem('placeholders');

  const [variantActive, setVariant] = useState(null);
  const [loadedGTM, setLoadedGTM] = useState(false);

  const productIdCurrent = useMemo(
    () => contextRouteItem?.['Commerce Product Source']?.fields?.ProductId?.value,
    [JSON.stringify(contextRouteItem)]
  );

  useDidUpdateEffect(() => {
    if (!variantActive) {
      setVariant({
        ...variantActiveDefault,
        ProductId: productIdCurrent
      });
    }
  }, [variantActiveDefault]);

  useDidUpdateEffect(() => {
    const isEnableTrackingViewItem = !(
      placeholders?.['osim-main']?.find((component) => component?.componentName === 'ProductDetailOverview')
    );
    if (isEnableTrackingViewItem) {
      if (isGA4) {
        const queryParams = new URLSearchParams(window.location.search);
        const pdpPromoCode = queryParams.get('cCode');
        const idxProdGA4 = global.getIndexGA4Param();
        let dataConvert = [];

        dataConvert.push(variantActive);

        let paramsViewItem = {
          ecommerce: {
            currency: variantActive?.Price?.CurrencyCode,
            value: variantActive?.Price?.SellingPrice,
            items: global.handleGA4ViewAndSelectItems(
              idxProdGA4,
              dataConvert,
              '',
              pdpPromoCode,
              productDetailOverview?.Brand
            )
          }
        };

        new GoogleAnalytic().ggGateWay('event', 'view_item', paramsViewItem);
      } else {
        let params = {
          items: [
            {
              id: productIdCurrent,
              name: SitecoreContextFactoryService.getValueContextRouteItem('name'),
              list_name: 'Search Results',
              brand: 'Osim',
              category: variantActive?.CategoryName,
              variant: variantActive?.Color,
              list_position: 1,
              quantity: variantActive?.Stock?.StockQuantity,
              price: variantActive?.Price?.SellingPrice
            }
          ]
        };

        new GoogleAnalytic().ggGateWay('event', 'view_item', params);
      }

      setLoadedGTM(prevState => !prevState);
    }
  }, [variantActive]);

  useDidUpdateEffect(() => {
    window.dataLayer = window.dataLayer || [];

    let params = {
      ecommerce: {
        detail: {
          products: [
            {
              name: variantActive?.ProductName,
              id: variantActive?.ProductId,
              price: variantActive?.Price?.SellingPrice.toString(),
              category: variantActive?.CategoryName
            }
          ]
        }
      }
    };

    window.dataLayer.push(params);
  }, [loadedGTM]);

  return (
    <></>
  );
};

GA4ViewItemEvent.propTypes = {
  productDetailOverview: object,
  variantActiveDefault: object
};

const mapStateToProps = (state) => (
  {
    productDetailOverview: state.productReducer.productDetailOverviewReducer.productDetailOverview,
    variantActiveDefault: state.productReducer.productDetailOverviewReducer.VariantActiveDefault
  }
);

export default connect(mapStateToProps)(GA4ViewItemEvent);